import React from 'react';
import Layout from '@/sections/Layout';

import Hero from '@/sections/pages/GasStations/Hero';
import Solutions from '@/sections/common/Solutions';
import Partners from '@/sections/common/Partners';
import Statistic from '@/sections/common/Statistic';
import Ecosystem from '@/sections/pages/GasStations/Ecosystem';
import Transactions from '@/sections/pages/GasStations/Transactions';
import Benefits from '@/sections/common/Benefits';
import Questions from '@/sections/pages/GasStations/Questions';
import Registration from '@/sections/common/Registration';
import News from '@/sections/common/News';

import NEWS_LIST from '@/mocks/storyNews';

import '@/sections/pages/GasStations/styles.scss';

const GasStations = ({ page }) => {
  const { gas_stations_fields: gasPage } = page.template;

  const HERO_DATA = {
    title: gasPage.heroTitle,
    titleHighlighted: gasPage.heroTitleHighlighted,
    subtitle: gasPage.heroSubtitle,
    list: gasPage.heroListItems || [],
  };

  const SOLUTION_DATA = {
    title: gasPage.solutionsTitle,
    subtitle: gasPage.solutionsSubtitle,
    list: (gasPage.solutionSwipeItems || []).map(
      ({ solutionSwipeText, solutionSwipeIcon }) => ({
        title: solutionSwipeText,
        iconSrc: solutionSwipeIcon?.sourceUrl,
      })
    ),
  };

  const PARTNERS_DATA = {
    partnersSubheader: gasPage.partnersSubheader,
    partnersBtns: (gasPage.partnersInfoButtons || []).map(
      ({ partnersInfoButtonText, partnersInfoButtonsLink }) => ({
        txt: partnersInfoButtonText,
        to: partnersInfoButtonsLink,
      })
    ),
    partnersList: (gasPage.partners || []).map(
      (
        {
          partnerImage,
          partnerPosition,
          partnerName,
          partnerInfoComment,
          partnerBenefitItems,
          partnerLogos,
        },
        index
      ) => ({
        id: index + 1,
        logo: partnerLogos?.sourceUrl,
        person: {
          avatar: partnerImage?.sourceUrl,
          name: partnerName,
          position: partnerPosition,
        },
        comment: partnerInfoComment,
        benefits: (partnerBenefitItems || []).map(
          ({ benefitType, benefitDescription }) => ({
            type: benefitType,
            text: benefitDescription,
          })
        ),
      })
    ),
  };

  const STAT_DATA = {
    list: (gasPage.statItems || []).map(({ statItemNumber, statItemText }) => ({
      number: statItemNumber,
      desc: statItemText,
    })),
  };

  const ECOSYSTEM_DATA = {
    title: gasPage.ecosystemTitle,
    desc: gasPage.ecosystemTextDescription,
    btn: {
      text: gasPage.ecosystemButton?.buttonText,
      to: gasPage.ecosystemButton?.buttonLink,
    },
  };

  const TRANSACTION_DATA = {
    card: {
      counter: gasPage.transTitle,
      desc: gasPage.transactionLead,
    },
  };

  const BENEFITS_DATA = {
    title: gasPage.benefitsTitle,
    benefits: (gasPage.benefitsTable || []).map((item) => ({
      iconSrc: item.tdIcon?.sourceUrl,
      name: item.tdIconText,
      traditional: item.tdTraditional,
      cirrus: `<span class="cr-green">${item.tdCirrusHighlighted}</span> ${item.tdCirrus}`,
    })),
  };

  const QUESTIONS_DATA = {
    title: gasPage.questionsTitle,
    subtitle: gasPage.questionsSubtitle,
    slides: (gasPage.questionsSwiperSlideItems || []).map(
      ({ slideQuestion, slideTopAnswer }) => ({
        question: slideQuestion,
        answer: slideTopAnswer,
      })
    ),
  };

  const REGISTRATION_DATA = {
    title: gasPage.registrationTitle,
    desc: gasPage.registrationLead,
    descHighlightedLink: {
      ...gasPage.registrationHighlightedLink,
    },
    formData: {
      btnTxt: gasPage.registrationSubmitButtonText,
      checkboxLabel: gasPage.registrationSubmitCheckboxlabel,
      checkboxLabelHighlighted: {
        ...gasPage.registrationSubmitCheckboxlabelHighlighted,
      },
      inputs: {
        ...gasPage.registrationInputs,
      },
    },
  };

  const NEWS_DATA = {
    title: gasPage.newsTitle,
    list: NEWS_LIST,
  };

  return (
    <Layout
      currentPageClass={'cr-gas-stat-page'}
      headerClass={'cr-gas-stat-header'}
      mainClass={'cr-gas-stat-main'}
      footerClass={'cr-gas-stat-footer'}
    >
      {(commonData) => (
        <>
          <section className="cr-gas-stat__hero">
            <Hero data={HERO_DATA} />
          </section>

          <section className="cr-wrap cr-gas-stat__solutions">
            <Solutions data={SOLUTION_DATA} />
          </section>

          <section className="cr-wrap cr-gas-stat__partners">
            <Partners data={PARTNERS_DATA} />
          </section>

          <section className="cr-wrap cr-gas-stat__stat">
            <Statistic data={STAT_DATA} />
          </section>

          <section className="cr-gas-stat__ecosystem">
            <Ecosystem data={ECOSYSTEM_DATA} />
          </section>

          <section className="cr-wrap cr-gas-stat__trans">
            <Transactions data={TRANSACTION_DATA} />
          </section>

          <section className="cr-wrap cr-gas-stat__benefits">
            <Benefits data={BENEFITS_DATA} />
          </section>

          <section className="cr-gas-stat__questions">
            <Questions data={QUESTIONS_DATA} />
          </section>

          <section className="cr-wrap cr-gas-stat__registr">
            <Registration data={REGISTRATION_DATA} />
          </section>

          <section className="cr-wrap cr-gas-stat__news">
            <News data={NEWS_DATA} />
          </section>
        </>
      )}
    </Layout>
  );
};

export default GasStations;
